import React, { FC } from 'react';
import { ProgramSelectorMenu } from '../program-selector-menu';
import { DesktopHeaderView, MobileHeaderView } from './components';
import { useHeaderTitleState } from './hooks';

export const HeaderTitle: FC = () => {
  const {
    account,
    tagData,
    program,
    isMenuOpen,
    desktopAnchorRef,
    mobileAnchorRef,
    handleMenuToggle,
    handleMenuClose,
    getCurrentAnchorEl,
  } = useHeaderTitleState();

  if (!account) {
    return null;
  }

  return (
    <>
      {/* Desktop View */}
      <DesktopHeaderView
        tagData={tagData}
        program={program}
        isMenuOpen={isMenuOpen}
        desktopAnchorRef={desktopAnchorRef}
        onMenuToggle={handleMenuToggle}
      />

      {/* Mobile View */}
      <MobileHeaderView
        tagData={tagData}
        program={program}
        account={account}
        isMenuOpen={isMenuOpen}
        mobileAnchorRef={mobileAnchorRef}
        onMenuToggle={handleMenuToggle}
      />

      {/* Program Selector Menu */}
      <ProgramSelectorMenu
        anchorEl={getCurrentAnchorEl()}
        isOpen={isMenuOpen}
        onClose={handleMenuClose}
      />
    </>
  );
};
